import { render, staticRenderFns } from "./FuxunPaymentChoice.vue?vue&type=template&id=3d9811cf&scoped=true"
import script from "./FuxunPaymentChoice.vue?vue&type=script&lang=js"
export * from "./FuxunPaymentChoice.vue?vue&type=script&lang=js"
import style0 from "./FuxunPaymentChoice.vue?vue&type=style&index=0&id=3d9811cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9811cf",
  null
  
)

export default component.exports